import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import Button from "../components/button";
import DealRequestCard from "../components/deal-request-card";
import axios from "../axios";
import { logEvent } from "../analytics";
import { EVENTS } from "../constants/ga-constants";
import { TutorsListComponent } from "./components/tutorsListComponent";
import { requestFirebaseNotificationPermission as getFcmPermissionToken } from "../notification";
import WhyChooseSlider from "./components/WhyChooseSlider";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
const currentDate = new Date();
const currentHour = currentDate.getHours();

export default function Dashboard({ setshowNavBar }) {
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [userId] = useState(JSON.parse(localStorage.getItem("userDetails"))?.userId);
  const [loading, setLoading] = useState(true);
  const [paymentPopUp, setPaymentPopUp] = useState(0);
  const [tutors, setTutors] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const rightSectionRef = useRef(null);
  const [rightSectionHeight, setRightSectionHeight] = useState(rightSectionRef.current?.clientHeight);
  const [planAmt, setPlanAmt] = useState(1000);
  const [activePayNow, setActivePayNow] = useState(false);
  useEffect(() => {
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-jwt"));
    if (!jwt) {
      navigate("/");
      window.location.reload();
    } else {
      setshowNavBar(true);
      getUserDashboardDetails();
      localStorage.setItem("dealData", JSON.stringify({}));
      // if(JSON.parse(localStorage.getItem("paymentPopUp")))setPaymentPopUp(true)
      setIsMobile(() => window.innerWidth <= 768);
    }
  }, []);

  const verifyStudentDetails = async (userId, data) => {
    try {
      await axios.post(`/v1/user/verify-payment`, {
        userId: userId,
      });
      const response = data.data;
      const userData = {
        profilePic: response.profile_pic,
        Name: response.user_name,
        userId: response.id,
        isAuthenticated: response.isAuthenticated,
      };
      userData.specialRequest = response.requests_data?.find(x => x.category_id === 13);

      let userDetails = userData;
      if (userData.specialRequest) {
        setPlanAmt(2000);
      } else {
        setPlanAmt(1000);
      }

      localStorage.setItem("userDetails", JSON.stringify(userData));
      // getTutorList();
      saveFcmToken();
      setUserDetails(userData);
      setDeals(response.requests_data);
      if (userDetails && userDetails.userId) {
        axios
          .get(`v1/student/subscription-status?student_id=${userDetails.userId}`)
          .then(data => {
            const response = data.data.data;
            setIsAuthenticated(response.status === "Subscribed");
            // Update localStorage with the latest userDetails and isAuthenticated status
            localStorage.removeItem("userDetails");
            const updatedUserDetails = { ...userDetails, isAuthenticated: response.status === "Subscribed" };

            localStorage.setItem("userDetails", JSON.stringify(updatedUserDetails));
            setUserDetails(updatedUserDetails); // Also update React state if needed
            setLoading(false);
          })
          .catch(err => { });
      }
      if (
        JSON.parse(localStorage.getItem("paymentPopUp")) &&
        !response.requests_data?.find(deal => deal.advance_payment > 0)
      ) {
        setPaymentPopUp(response.requests_data[0]?.advance_amount);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const buySubscription = async planId => {
    setIsLoading(true);
    setActivePayNow(true);
    try {
      // Step 1: Create order from backend
      const {
        data: { data: order },
      } = await axios.post("v1/student/create-order", {
        planType: planAmt === 1000 ? "Basic" : "Special",
        isStudent: true,
      });

      const user = JSON.parse(localStorage.getItem("userDetails"));

      // Step 2: Configure Razorpay
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency,
        name: "HomeShiksha",
        description: "HomeHomeShikshash Plan",
        order_id: order.id,
        callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/tutor/order-payment-verification?userId=${user.userId
          }&planType=${planAmt === 1000 ? "Basic" : "Special"}&isStudent=true`, // ✅ backend URL
        // prefill: {
        //   name: "HomeShiksha",
        //   email: "homeshiksha@gmail.com",
        //   contact: "9876543210",
        // },
        theme: {
          color: "#2B93A5",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      setLoading(false);
      console.error("Payment Error:", error);
    }
    // try {
    //   const payload = {
    //     planId: planAmt === 2000 ? "plan_ROZ1UKuvncyeXV" : "plan_RNnGWybdWJBpfx",
    //     userId: JSON.parse(localStorage.getItem("userDetails"))?.userId,
    //   };
    //   const { data } = await axios.post(`v1/plans`, payload);
    //   setSubscriptionId(data?.subscriptionId);
    //   setIsLoading(false);
    // } catch (error) {
    //   setIsLoading(false);
    //   console.error(error);
    // }
  };
  const saveFcmToken = async () => {
    getFcmPermissionToken().then(token => {
      if (token) {
        axios.post("/v1/save-notification-token", {
          userId: JSON.parse(localStorage.getItem("userDetails"))?.userId,
          token: token,
        });
      }
    });
  };

  useEffect(() => {
    if (subscriptionId) {
      const openPopUp = () => {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          name: "HomeShiksha",
          description: "Access to HomeShiksha",
          image: "./profile.jpg",
          subscription_id: subscriptionId,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/subscriptions`,
          prefill: {
            name: "HomeShiksha",
            email: "homeshiksha@gmail.com",
            contact: "9876543210",
          },
          notes: {
            address: "HomeShiksha",
          },
          theme: {
            color: "#2B93A5",
          },
        };

        const razor = new window.Razorpay(options);
        razor.open();
      };
      openPopUp();
    }
  }, [subscriptionId, userId]);

  const getUserDashboardDetails = () => {
    let userDetails = null;
    try {
      axios
        .get(`v1/student/dashboard`)
        .then(data => {
          verifyStudentDetails(data.data.id, data);
        })
        .catch(err => { });
    } catch (error) { }
  };

  const timeOfDay = () => {
    let timeOfDay;

    if (currentHour >= 5 && currentHour < 12) {
      timeOfDay = "Morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      timeOfDay = "Afternoon";
    } else {
      timeOfDay = "Evening";
    }
    return timeOfDay;
  };

  const hidepopUP = () => {
    localStorage.setItem("paymentPopUp", JSON.stringify(false));
    setPaymentPopUp(0);
  };

  const getTutorList = () => {
    const userId = JSON.parse(localStorage.getItem("userDetails"))?.userId;
    axios.get(`v1/student/details-from-deal?userId=${userId}&page=0&limit=2`).then(response => {
      setTutors(response?.data?.data);
    });
  };

  const payNow = () => {
    axios
      .post("v1/subscribe-to-plan")
      .then(response => {
        const requestData = response.data;
        if (requestData.data.includes("https:")) {
          setTimeout(() => {
            window.open(requestData.data, "_blank");
          });
        }
      })
      .catch(err => { });
  };

  useMemo(() => {
    setRightSectionHeight(rightSectionRef.current?.clientHeight);
  }, [rightSectionRef.current?.clientHeight]);

  return !loading ? (
    <main className="main">
      {paymentPopUp !== 0 && (
        <div className="dashboard-payment-popup">
          <div className="tutor-popup-wrapper--content-screen" style={{ zIndex: 81 }}>
            <div
              style={{ textAlign: "end", margin: "3px 8px", cursor: "pointer" }}
              onClick={() => {
                hidepopUP();
              }}>
              Close
            </div>

            <div
              className="pending--wrapper"
            >
              {
                <div className="payment-pending--wrapper" style={{ padding: "30px 20px", backgroundColor: "white" }}>
                  <div
                    className="payment-pending--title"
                    style={{ color: "#2B93A5", fontSize: "24px", marginBottom: "15px" }}>
                    Upgrade to HOMESHIKSHA PREFERRED CUSTOMER
                  </div>
                  <div
                    className="payment-pending--description"
                    style={{
                      color: "#333",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "1.5",
                      marginBottom: "20px",
                      textAlign: "center",
                    }}>
                    *We get over 500 requirements for tutors daily. Sometimes its not possible for us to arrange
                    tutors for everyone. If you genuinely have a requirement for a tutor, then pay this small
                    'refundable' fee of Rs.{planAmt} and your requirement will be given first priority.
                  </div>
                  {!activePayNow ? (
                    <div
                      className="payment-pending--paynow-btn"
                      style={{
                        margin: "15px auto",
                        width: "180px",
                      }}
                      onClick={() => {
                        buySubscription("plan_RNnGWybdWJBpfx");
                      }}>
                      <div
                        style={{
                          backgroundColor: "#2B93A5",
                          color: "white",
                          padding: "12px 30px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          textAlign: "center",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        }}>
                        {isLoading ? "Loading..." : "Pay now"}
                      </div>
                      {/* To reflect Your Payment transaction */}
                    </div>
                  ) : (
                    <div
                      className="payment-pending--paynow-btn"
                      style={{
                        margin: "15px auto",
                        width: "180px",
                      }}
                      onClick={() => {
                        setActivePayNow(false);
                        setIsLoading(false);
                      }}>
                      <div
                        style={{
                          backgroundColor: "#2B93A5",
                          color: "white",
                          padding: "12px 30px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          cursor: "pointer",
                          textAlign: "center",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        }}>
                        Click here
                      </div>
                      <div style={{ textAlign: "center", marginTop: "5px", fontSize: "14px" }}>
                        To reflect Your Payment transaction
                      </div>
                    </div>
                  )}
                  <div
                    className="payment-pending--payment-amount"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#333",
                      marginTop: "10px",
                    }}>
                    Advance Payment {planAmt}/-
                  </div>
                </div>
              }
              <div className="pending--process-wrapper">
                <div
                  className="inner-pending--process-wrapper"
                  style={{
                    backgroundColor: "#EDFCFF",
                    padding: "25px 30px",
                    borderRadius: "16px",
                  }}>
                  <div
                    className="pending--process--title"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "15px",
                    }}>
                    Process:
                  </div>
                  <div className="pending--process--steps--wrapper">
                    <div style={{ marginBottom: "20px" }}>
                      {[1, 2, 3, 4, 5].map((num, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "12px",
                          }}>
                          <div style={{ color: "#2B93A5", marginRight: "10px", fontWeight: "600" }}>▶</div>
                          <div style={{ color: "#333", fontSize: "16px", lineHeight: "1.5" }}>
                            {num === 1 && "Team will contact you within 1-2 working hour."}
                            {num === 2 && "Your requirement will be put on first priority."}
                            {num === 3 &&
                              "Dedicated Customer Relationship manager will be assigned to handle your requirement."}
                            {num === 4 &&
                              "This amount is fully refundable in case we are not able to Provide you the tutor as per your need."}
                            {num === 5 &&
                              `You will become our subscribed customer for ${userDetails.specialRequest && planAmt === 2000 ? "12" : "6"
                              } months. You will can avail free tutor replacements and have the option to request an unlimited number of tutors during this period.`}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="pending--payment--TC"
                style={{
                  textAlign: "center",
                  padding: "15px 0",
                  borderTop: "1px solid #E0E0E0",
                  fontSize: "14px",
                  color: "#555",
                }}>
                ★ This amount is fully refundable in case we are not able to Provide you the tutor as per your need ★
                <div style={{ marginTop: "5px", fontSize: "12px", color: "#777" }}>Terms and conditions applied*</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && (
        <section className="request-deals--wrapper--right-section">
          <WhyChooseSlider userDetails={userDetails} />
        </section>
      )}

      <section className={`greetings--wrapper ${isAuthenticated ? "greetings--wrapper-Authenticated" : ""}`}>
        <div className="greetings--wrapper--info-wrapper">
          {!isMobile ? (
            <>
              <li className="dropdown profile-avatar profile-avatar-big pl-2">
                <img
                  src={
                    userDetails.profilePic != undefined && userDetails.profilePic != "null"
                      ? userDetails.profilePic
                      : "./profile.jpg"
                  }
                  alt="avatar"
                />
              </li>
            </>
          ) : (
            <div className="profilePic--wrapper">
              <img
                src={
                  userDetails.profilePic != undefined && userDetails.profilePic != "null"
                    ? userDetails.profilePic
                    : "./person-icon.png"
                }
                alt="user profile pic"
                height="50"
              />
            </div>
          )}

          <div className="greetings--info">
            <div className="greetings--user">
              Good {timeOfDay()} {userDetails?.Name?.split(" ")[0]} !
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="user--overview">
                {isAuthenticated
                  ? "You are a HomeShiksha Preferred Customer"
                  : "You are not yet a HomeShiksha Preferred Customer"}

                {isAuthenticated ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ cursor: "pointer" }}>
                    <path
                      d="M16.1336 7.50004V5.53337C16.1336 5.09134 15.958 4.66742 15.6455 4.35486C15.3329 4.0423 14.909 3.8667 14.4669 3.8667H12.5419L11.1753 2.50004C10.863 2.18962 10.4406 2.01538 10.0003 2.01538C9.55997 2.01538 9.13755 2.18962 8.82528 2.50004L7.50028 3.8667H5.53361C5.09159 3.8667 4.66766 4.0423 4.3551 4.35486C4.04254 4.66742 3.86695 5.09134 3.86695 5.53337V7.50004L2.50028 8.82504C2.18986 9.13731 2.01562 9.55973 2.01562 10C2.01562 10.4403 2.18986 10.8628 2.50028 11.175L3.86695 12.5417V14.4667C3.86695 14.9087 4.04254 15.3327 4.3551 15.6452C4.66766 15.9578 5.09159 16.1334 5.53361 16.1334H7.50028L8.82528 17.5C9.13755 17.8105 9.55997 17.9847 10.0003 17.9847C10.4406 17.9847 10.863 17.8105 11.1753 17.5L12.5419 16.1334H14.4669C14.909 16.1334 15.3329 15.9578 15.6455 15.6452C15.958 15.3327 16.1336 14.9087 16.1336 14.4667V12.5417L17.5003 11.175C17.8107 10.8628 17.9849 10.4403 17.9849 10C17.9849 9.55973 17.8107 9.13731 17.5003 8.82504L16.1336 7.50004Z"
                      fill="#2196F3"
                    />
                    <path
                      d="M9.37496 12.0834C9.26529 12.084 9.15657 12.063 9.05504 12.0215C8.95351 11.98 8.86116 11.9189 8.78329 11.8417L7.49996 10.5917C7.34304 10.4348 7.25488 10.222 7.25488 10C7.25488 9.77812 7.34304 9.56529 7.49996 9.40837C7.65688 9.25145 7.86971 9.1633 8.09163 9.1633C8.31354 9.1633 8.52637 9.25145 8.68329 9.40837L9.34163 10.075L11.25 8.15837C11.4069 7.99261 11.6232 7.89598 11.8514 7.88973C12.0796 7.88348 12.3009 7.96812 12.4666 8.12504C12.6324 8.28196 12.729 8.4983 12.7353 8.72647C12.7415 8.95464 12.6569 9.17595 12.5 9.34171L9.99996 11.8417C9.91818 11.9231 9.8204 11.9865 9.71282 12.0281C9.60524 12.0697 9.49019 12.0885 9.37496 12.0834Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    data-tooltip-id="preferred-customer-tooltip"
                    data-tooltip-content="Only Preferred parent gets the facility to avail Home tutor with us."
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 18.125C14.1421 18.125 17.5 14.7671 17.5 10.625C17.5 6.48286 14.1421 3.125 10 3.125C5.85786 3.125 2.5 6.48286 2.5 10.625C2.5 14.7671 5.85786 18.125 10 18.125Z"
                      fill="#FFBB33"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.9656 6.85411L10.6817 12.6172C10.6628 13.0011 10.3749 13.3168 9.99989 13.3168C9.62489 13.3168 9.33696 13.0015 9.31806 12.6172L9.03417 6.85411C8.98246 5.79846 11.0174 5.7988 10.9656 6.85411Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.0002 13.8243C10.3766 13.8243 10.6819 14.1296 10.6819 14.5061C10.6819 14.8826 10.3766 15.1879 10.0002 15.1879C9.62367 15.1879 9.31836 14.8826 9.31836 14.5061C9.31836 14.1296 9.62367 13.8243 10.0002 13.8243Z"
                      fill="white"
                    />
                  </svg>
                )}
              </div>
              {/* <div className="greetings--wrapper--new-request-btn-mobile">
                <NavLink to="/new-request">
                  <Button>New Request</Button>
                </NavLink>
              </div> */}
            </div>
          </div>
        </div>
        {/* <div className="greetings--wrapper--new-request-btn-desktop">
          <NavLink to="/new-request">
            <Button>New Request</Button>
          </NavLink>
        </div> */}
      </section>
      {!isAuthenticated && (
        <section>
          <div className="subscribe-alert">
            <span className="warning-icon">⚠️</span>
            <span className="subscribe-text">Subscribe now to the HomeShiksha Preferred Customer Plan!</span>
            <span
              onClick={() => {
                setPaymentPopUp(1000);
                // payNow();
                // logEvent(EVENTS.PAY_NOW_BUTTON.event_name);
              }}
              className="subscribe-link">
              Subscribe now
            </span>
          </div>
        </section>
      )}

      <div className="request-deals--wrapper--left--title">Current request</div>
      <section className="request-deals--wrapper">
        <section className="request-deals--wrapper--left-section" style={{ maxHeight: rightSectionHeight }}>
          <div
            className="request-deals--wrapper--left"
            onClick={() => {
              logEvent(EVENTS.CARD_CLICKED.event_name);
            }}>
            {deals
              ?.slice()
              .reverse()
              .map((i, indx) => (
                <DealRequestCard key={indx} data={i} />
              ))}
          </div>
        </section>

        {!isMobile && (
          <section className="request-deals--wrapper--right-section">
            <WhyChooseSlider from={"dashboard"} userDetails={userDetails} />
          </section>
        )}
      </section>
      {/* <TutorsListComponent tutors={tutors} /> */}

      <div className="ads-space--wrapper">
        <strong> What type of tuition are you looking for?</strong>
        <div className="d-flex gap-3 align-center">
          <NavLink to="/new-academy-request">
            <div className="formtype-select-option-2" onClick={() => { }}>
              <img src="/academy-icon.svg" alt="academy icon" className="" />
              <span style={{ color: "rgba(0, 141, 240, 1)", textAlign: "center" }}>Academy</span>
            </div>
          </NavLink>

          <div
            className="formtype-select-option-1"
            onClick={() => {
              localStorage.setItem(
                "dealData",
                JSON.stringify({
                  advance_payment: 0,
                  base_module_student_id: "",
                  category_id: 2,
                  color: "#FF0000",
                  created_at: "",
                  id: "",
                  status: "newRequest",
                  student_requirments: "",
                  tution_type: "",
                }),
              );
              navigate("/deal-details");
              logEvent(EVENTS.CARD_CLICKED.event_name);
            }}>
            <img src="/curricular-icon.svg" alt="Curricular icon" />
            <span style={{ color: "rgba(53, 53, 53, 1)", textAlign: "center" }}>Curricular</span>
          </div>
        </div>
      </div>
      {/* Tooltip root */}
      <Tooltip id="preferred-customer-tooltip" place="top" />
      {/* <TutorsListComponent title="Language Tutors near you" seeAllLink="/" tutors={tutors} /> */}
    </main>
  ) : (
    <main className="main">
      <div
        className="loading"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}>
        <img src="./book-loader.gif" alt=" Loading . . .  " />
      </div>
    </main>
  );
}
